var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('img',{staticClass:"img-fluid mx-auto",class:{hide: !_vm.show, 'd-block': _vm.show },attrs:{"src":_vm.src,"alt":_vm.alt}})])}
var staticRenderFns = []

export { render, staticRenderFns }